import moment from "moment";
import React from "react";

const Timer = (props) => {
  const [HH, setHH] = React.useState(null);
  const [MM, setMM] = React.useState(null);
  const [SS, setSS] = React.useState(null);
  const [sec, setSec] = React.useState(props.sec);

  React.useEffect(() => {
    const h = Math.floor(sec / 60 / 60);
    const m = Math.floor((sec - h * 3600) / 60);
    // const s = Math.floor(sec - m * 60);
    const s = Math.floor(sec - h * 3600 - m * 60);

    // var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    // var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    // var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    const hh = String(h).padStart(2, "0");
    const mm = String(m).padStart(2, "0");
    const ss = String(s).padStart(2, "0");

    const intervalId = setTimeout(() => {
      setSec(sec - 1);
      setHH(hh);
      setMM(mm);
      setSS(ss);

      if (sec < 2) {
        props.onComplete();
        clearTimeout(intervalId);
      }
    }, 1000);

    return () => clearTimeout(intervalId);
  }, [SS]);

  return (
    <div className={props.className}>
      {!!props.sec > 0 && HH !== null ? `${HH}:${MM}:${SS}` : "00:00:00"}
    </div>
  );
};

export default Timer;
